import LMFDataEntry from "../../pages/lmf/data-entry";
import LMFProcesses from "../../pages/lmf/lmf-processes";
import ProductionReport from "../../pages/production-report";
import { RouteConfig } from "./types";

// Define LMF routes with flat structure
export const lmfRoutes: RouteConfig[] = [
  {
    path: "/lmf-processes",
    element: <LMFProcesses />,
    permission: "ui.navbar.lmf.processes",
  },
  {
    path: "/lmf-processes/:shiftId",
    element: <LMFProcesses />,
    permission: "ui.navbar.lmf.processes",
  },
  {
    path: "/lmf-data-entry",
    element: <LMFDataEntry />,
    permission: "ui.navbar.lmf.data-entry",
  },
  {
    path: "/lmf-data-entry/:processId",
    element: <LMFDataEntry />,
    permission: "ui.navbar.lmf.data-entry",
  },
  {
    path: "/production-report",
    element: <ProductionReport />,
    permission: "ui.navbar.lmf.processes",
  },
];
